import { color_shades_dark, dark_grey_blue_10 } from "./colors";

export const style_border_default = `1px solid ${color_shades_dark}`
export const style_border_dotted = `1px dotted ${color_shades_dark}`
export const style_shadow_default = `0 2px 4px 0 ${dark_grey_blue_10}`